import {_ as _svelte} from 'svelte-i18n';
import {get} from 'svelte/store';

export const _ = (key, settings = {}) => {
    // console.log('key', key, i18next.t(key, settings));

    // if (typeof i18next === 'undefined') {
    //     return key
    // }
    //
    // return i18next.t(key, settings)

    // // This is workaround for i18next
    // let locale = require('../locale/pl/geoanalytics.json');
    // if (typeof locale[key] !== 'undefined') {
    //     return locale[key];
    // }

    return get(_svelte)(key); // FIXME: add i18next support
}